import axiosInstance from "../Axios";

const getOdd = (pageNo = 1, params) => {
  try {
    const queryParams = { pageNo };
    if (params && Object.keys(params).length > 0) {
      Object.assign(queryParams, params);
    }

    if (params.export) {
      return axiosInstance.get("/odd", {
        params: queryParams,
        responseType: "blob",
      });
    }

    return axiosInstance.get("/odd", { params: queryParams });
  } catch (error) {
    console.error("Error fetching odd data:", error);
    throw error;
  }
};

const submitOdd = (data) => {
  try {
    return axiosInstance.post("/odd/add-edit", data);
  } catch (error) {
    console.error("Error submitting odd data:", error);
    throw error;
  }
};

const approveRejectCancel = (id, action, reason = "") => {
  try {
    const data = {
      id,
      action,
      reason,
    };

    return axiosInstance.patch("/odd/approve-reject-cancel", data);
  } catch (error) {
    console.log("error in odd actions", error);
    throw error;
  }
};

const getOddById = (id) => {
  try {
    return axiosInstance.get(`/odd/details/${id}`);
  } catch (error) {
    console.error("Error fetching odd by ID:", error);
    throw error;
  }
};

export { getOdd, submitOdd, approveRejectCancel, getOddById };
